import { render, staticRenderFns } from "./NewVideoItem.vue?vue&type=template&id=66937950&"
import script from "./NewVideoItem.vue?vue&type=script&lang=js&"
export * from "./NewVideoItem.vue?vue&type=script&lang=js&"
import style0 from "./NewVideoItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports